<template>
  <section class="section-book">
    <div class="row">
      <div class="book">
        <div class="book__form">
          <form
            action="#"
            class="form"
          >
            <div class="u-margin-bottom-medium">
              <h2 class="heading-secondary">
                Make Contact
              </h2>
              <h3>It's easier to contact me via <a
                :href="'mailto:'+this.$store.getters.email" target="_blank" rel="noopener noreferrer"
              >Email</a>, <a
                :href="this.$store.getters.twitter_link" target="_blank" rel="noopener noreferrer"
              >X/Twitter</a>, or <a
                :href="this.$store.getters.linkedin_link" target="_blank" rel="noopener noreferrer"
              >Linkedin</a>, but if you insist...</h3>
            </div>
            <div class="form__group">
              <input
                id="name"
                v-model="name"
                type="text"
                class="form__input"
                placeholder="Full name"
                required
                autocomplete="off"
              >
              <label
                for="name"
                class="form__label"
              >Full name</label>
            </div>

            <div class="form__group u-margin-bottom-small">
              <input
                id="email"
                v-model="email"
                type="email"
                class="form__input"
                placeholder="Email address"
                required
                autocomplete="off"
              >
              <label
                for="email"
                class="form__label"
              >Email address</label>
            </div>
            <div class="form__group u-margin-bottom-small">
              <textarea
                id="message"
                v-model="message"
                type="message"
                class="form__input"
                placeholder="Please put your message here"
                required
                autocomplete="off"
              />
              <label
                for="Message"
                class="form__label"
              >Please put your message here</label>
            </div>

            <div class="form__group u-margin-bottom-small">
              <div class="form__radio-group">
                <input
                  id="small"
                  v-model="contactReason"
                  type="radio"
                  class="form__radio-input"
                  name="size"
                  value="Website Design"
                >
                <label
                  for="small"
                  class="form__radio-label"
                >
                  <span class="form__radio-button" />
                  Website Design
                </label>
              </div>

              <div class="form__radio-group u-margin-bottom-small">
                <input
                  id="large"
                  v-model="contactReason"
                  type="radio"
                  class="form__radio-input"
                  name="size"
                  value="Machine Learning"
                >
                <label
                  for="large"
                  class="form__radio-label"
                >
                  <span class="form__radio-button" />
                  Machine Learning
                </label>
              </div>
            </div>
            
            <div class="form__group">
              <button
                class="btn btn--primary"
                @click.prevent="makeContact"
              >
                Next step &rarr;
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { postEnquiryToFirebase } from '@/functions/enquiries'

export default {
  name: 'Contact',
   data () {
    return {
      email: null,
      name: null,
      message: null,
      contactReason: "",
      rate_limit_traker: 0
    }
  },

  methods: {
    clearForm() {
      this.email = null
      this.name = null
      this.message = null
      this.contactReason = ""
    },

    makeContact() {
      if (this.rate_limit_traker < 1) {
        postEnquiryToFirebase(this.email, this.name, this.message, this.contactReason)
             this.$toasted.show('Message has been sent!', {
                position: 'top-center',
                action: {
                  text: 'Okay',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                }
      
              },
              this.clearForm())
              this.rate_limit_traker += 1
            }
            else{
              this.$toasted.show('You have already sent a message!', {
                position: 'top-center',
                action: {
                  text: 'Okay',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                }
                
      
              },
              ),
              this.clearForm()
            }
      }
    }
   
  }
</script>